import React from "react";
import { Modal, Form, Row, Col, Stack, Badge, Button } from "react-bootstrap";
import { XCircleFill } from "react-bootstrap-icons";

const ModalEditareContract = ({
  show,
  onHide,
  contractCurent,
  setContractCurent,
  toatePartizile,
  partiziDisponibileEdit,
  volumEdit,
  valoareEdit,
  tratezEditare
}) => {
  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Modifică Contract: {contractCurent?.partener}</Modal.Title>
      </Modal.Header>
      <Form onSubmit={tratezEditare}>
        <Modal.Body>
          {contractCurent && (
            <>
              <Row>
                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-bold">Partener / Firmă</Form.Label>
                    <Form.Control
                      type="text"
                      value={contractCurent.partener}
                      onChange={(e) => setContractCurent({ ...contractCurent, partener: e.target.value })}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>

              <div className="mb-3">
                <Form.Label className="fw-bold text-success">Partizi incluse actual:</Form.Label>
                <div className="p-2 border rounded mb-2 border-success">
                  <Stack direction="horizontal" gap={2} className="flex-wrap">
                    {contractCurent.partiziAferente?.map((id) => {
                      const p = toatePartizile.find((part) => part.id === id);
                      return (
                        <Badge key={id} bg="success" className="p-2 d-flex align-items-center">
                          {p?.fond} ({p?.volBrut} mc)
                          <XCircleFill
                            className="ms-2"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              const noiPartizi = contractCurent.partiziAferente.filter((pid) => pid !== id);
                              setContractCurent({ ...contractCurent, partiziAferente: noiPartizi });
                            }}
                          />
                        </Badge>
                      );
                    })}
                  </Stack>
                </div>

                <Form.Label className="fw-bold text-primary">Adaugă partizi disponibile ({contractCurent.ocol}):</Form.Label>
                <div className="p-2 border rounded bg-light">
                  <Stack direction="horizontal" gap={2} className="flex-wrap">
                    {partiziDisponibileEdit
                      .filter((p) => !(contractCurent.partiziAferente || []).includes(p.id))
                      .map((p) => (
                        <Button
                          key={p.id}
                          variant="outline-primary"
                          size="sm"
                          onClick={() => {
                            const noiPartizi = [...(contractCurent.partiziAferente || []), p.id];
                            setContractCurent({ ...contractCurent, partiziAferente: noiPartizi });
                          }}
                        >
                          + {p.fond}
                        </Button>
                      ))}
                  </Stack>
                </div>
              </div>

              <Row className="bg-warning bg-opacity-10 p-2 rounded mx-0">
                <Col className="text-center border-end">
                  <small className="d-block text-muted">Volum actualizat</small>
                  <strong>{volumEdit.toFixed(2)} mc</strong>
                </Col>
                <Col className="text-center">
                  <small className="d-block text-muted">Valoare actualizată</small>
                  <strong>{valoareEdit.toFixed(2)} RON</strong>
                </Col>
              </Row>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>Anulează</Button>
          <Button variant="primary" type="submit">Salvează Modificările</Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ModalEditareContract;